import { debounce } from 'lodash';

let debouncedPageTitleUpdate;

const plugin = () => ({
  initialize: ({ getProps }) => {
    const { page } = getProps();
    debouncedPageTitleUpdate = debounce(page.setTitle, 250);
  },
  onChange: (editorState, { getProps }) => {
    // console.log('onChange', blockType, dataKey);
    const { page, readOnly } = getProps();
    if (readOnly) return editorState;
    const contentState = editorState.getCurrentContent();
    const blockMap = contentState.getBlockMap();
    const titleBlock = blockMap.find(b => b.getType() === 'title');
    if (!titleBlock) return editorState;
    const title = titleBlock.getText();
    if (title !== page.title) {
      debouncedPageTitleUpdate(title);
    }
    return editorState;
  },
});

export default plugin;
